import { Builder } from '@builder.io/sdk';
import Hero from './Hero';

const HeroConfig = {
  name: 'Hero',
  friendlyName: 'Hero',
  inputs: [
    {
      name: 'text',
      type: 'string',
    },
  ],
  defaultStyles: {
    margin: '0',
  },
};

Builder.registerComponent(Hero, HeroConfig);
